/*
 * @Descripttion: 备忘提醒 - 提醒类型工具（-1未设置，0不重复，1每天，2每周，3每月）
 * @version:
 * @Author: geory
 * @Date: 2026-08-14 17:30:00
 * @LastEditors: geory
 * @LastEditTime: 2026-08-14 17:30:00
 */
export const REMIND_TYPE_NONE = -1;
export const REMIND_TYPE_ONCE = 0;
export const REMIND_TYPE_DAILY = 1;
export const REMIND_TYPE_WEEKLY = 2;
export const REMIND_TYPE_MONTHLY = 3;

// 1=周一 ... 7=周日
export const WEEKDAY_NAMES = ["", "一", "二", "三", "四", "五", "六", "日"];

//备忘列表缓存：提醒调度器使用「列表刷新时」的数据，不额外轮询服务端
let memoListCache = [];

export function setMemoListCache(list) {
  memoListCache = Array.isArray(list) ? list : [];
}

export function getMemoListCache() {
  return memoListCache;
}

//「是否同步日历」开关的默认值（用户勾选过一次后记住，后续默认勾选）
const SYNC_CALENDAR_KEY = "wminput:memo:syncCalendarDefault";

//是否Windows平台（Windows版停用系统日历同步，仅本地通知+系统通知）
export function isWindowsPlatform() {
  return (
    typeof navigator !== "undefined" &&
    /win/i.test(String(navigator.userAgent || navigator.platform || ""))
  );
}

export function getSyncCalendarDefault() {
  try {
    return localStorage.getItem(SYNC_CALENDAR_KEY) === "1";
  } catch (e) {
    return false;
  }
}

export function setSyncCalendarDefault(val) {
  try {
    localStorage.setItem(SYNC_CALENDAR_KEY, val ? "1" : "0");
  } catch (e) {}
}

function pad(n) {
  return n < 10 ? "0" + n : "" + n;
}

//解析 byWeekDay：支持 "[1,3,7]"、"1,3,7"、数组
export function parseByWeekDay(str) {
  if (Array.isArray(str)) {
    return str.map(Number).filter((n) => n >= 1 && n <= 7);
  }
  if (!str) {
    return [];
  }
  try {
    const arr = JSON.parse(String(str));
    if (Array.isArray(arr)) {
      return arr.map(Number).filter((n) => n >= 1 && n <= 7);
    }
  } catch (e) {}
  return String(str)
    .split(",")
    .map((s) => parseInt(s.replace(/[\[\]]/g, ""), 10))
    .filter((n) => n >= 1 && n <= 7);
}

//byDayTime(毫秒，从0点起) -> "H:mm"
export function byDayTimeToHHmm(ms) {
  const totalMin = Math.floor(Math.max(0, Number(ms) || 0) / 60000);
  const h = Math.floor(totalMin / 60) % 24;
  const m = totalMin % 60;
  return h + ":" + pad(m);
}

//时、分 -> byDayTime 毫秒
export function hhmmToByDayTime(h, m) {
  return h * 3600000 + m * 60000;
}

//时间戳毫秒 -> "M月d日 H:mm"
export function formatDateTime(ms) {
  const d = new Date(Number(ms));
  if (isNaN(d.getTime())) {
    return "";
  }
  return (
    d.getMonth() + 1 + "月" + d.getDate() + "日 " + d.getHours() + ":" + pad(d.getMinutes())
  );
}

//备忘提醒展示文案
export function formatRemind(item) {
  if (!item || item.remindType == null || item.remindType == REMIND_TYPE_NONE) {
    return "";
  }
  if (item.remindType == REMIND_TYPE_ONCE) {
    return item.notRepeatTime ? formatDateTime(item.notRepeatTime) : "";
  }
  const hm = byDayTimeToHHmm(item.byDayTime);
  if (item.remindType == REMIND_TYPE_DAILY) {
    return "每天 " + hm;
  }
  if (item.remindType == REMIND_TYPE_WEEKLY) {
    const days = parseByWeekDay(item.byWeekDay)
      .slice()
      .sort((a, b) => a - b);
    if (!days.length) {
      return "";
    }
    return "每周" + days.map((d) => WEEKDAY_NAMES[d]).join("、") + " " + hm;
  }
  if (item.remindType == REMIND_TYPE_MONTHLY) {
    return "每月" + (item.byMonthDay || 1) + "日 " + hm;
  }
  return "";
}

//计算下一次提醒发生时间（日历事件 DTSTART 用），无有效提醒返回 null
export function nextOccurrence(item, from) {
  if (!item) {
    return null;
  }
  const base = from ? new Date(from) : new Date();
  if (item.remindType == REMIND_TYPE_ONCE) {
    const t = new Date(Number(item.notRepeatTime));
    return isNaN(t.getTime()) ? null : t;
  }
  const hm = byDayTimeToHHmm(item.byDayTime).split(":");
  const h = parseInt(hm[0], 10);
  const m = parseInt(hm[1], 10);
  if (item.remindType == REMIND_TYPE_DAILY) {
    const d = new Date(base);
    d.setHours(h, m, 0, 0);
    if (d.getTime() <= base.getTime()) {
      d.setDate(d.getDate() + 1);
    }
    return d;
  }
  if (item.remindType == REMIND_TYPE_WEEKLY) {
    const days = parseByWeekDay(item.byWeekDay);
    if (!days.length) {
      return null;
    }
    for (let i = 0; i < 8; i++) {
      const d = new Date(base);
      d.setDate(base.getDate() + i);
      d.setHours(0, 0, 0, 0);
      const wd = d.getDay() === 0 ? 7 : d.getDay(); // 1=周一 ... 7=周日
      if (days.indexOf(wd) >= 0) {
        d.setHours(h, m, 0, 0);
        if (d.getTime() > base.getTime()) {
          return d;
        }
      }
    }
    return null;
  }
  if (item.remindType == REMIND_TYPE_MONTHLY) {
    const day = item.byMonthDay || 1;
    const d = new Date(base);
    d.setDate(day);
    d.setHours(h, m, 0, 0);
    if (d.getTime() <= base.getTime()) {
      d.setMonth(d.getMonth() + 1);
      d.setDate(day);
      d.setHours(h, m, 0, 0);
    }
    return d;
  }
  return null;
}

//日历重复规则（RRULE），非重复返回空字符串
export function remindRrule(item) {
  if (!item) {
    return "";
  }
  if (item.remindType == REMIND_TYPE_DAILY) {
    return "FREQ=DAILY";
  }
  if (item.remindType == REMIND_TYPE_WEEKLY) {
    const days = parseByWeekDay(item.byWeekDay)
      .slice()
      .sort((a, b) => a - b);
    if (!days.length) {
      return "";
    }
    const map = { 1: "MO", 2: "TU", 3: "WE", 4: "TH", 5: "FR", 6: "SA", 7: "SU" };
    return "FREQ=WEEKLY;BYDAY=" + days.map((d) => map[d]).join(",");
  }
  if (item.remindType == REMIND_TYPE_MONTHLY) {
    return "FREQ=MONTHLY;BYMONTHDAY=" + (item.byMonthDay || 1);
  }
  return "";
}

//判断备忘的提醒是否在「当前时间往前 windowMs 毫秒内」刚刚到期（用于到点弹横幅）
export function isReminderDue(item, now, windowMs) {
  if (!item || item.remindType == null || item.remindType == REMIND_TYPE_NONE) {
    return false;
  }
  const t = now != null ? new Date(now) : new Date();
  const w = windowMs || 60 * 1000;
  if (item.remindType == REMIND_TYPE_ONCE) {
    const ts = Number(item.notRepeatTime) || 0;
    return ts > 0 && ts <= t.getTime() && ts > t.getTime() - w;
  }
  const hm = byDayTimeToHHmm(item.byDayTime).split(":");
  const h = parseInt(hm[0], 10);
  const m = parseInt(hm[1], 10);
  const todayAt = new Date(t);
  todayAt.setHours(h, m, 0, 0);
  const inWindow =
    todayAt.getTime() <= t.getTime() && todayAt.getTime() > t.getTime() - w;
  if (item.remindType == REMIND_TYPE_DAILY) {
    return inWindow;
  }
  if (item.remindType == REMIND_TYPE_WEEKLY) {
    const days = parseByWeekDay(item.byWeekDay);
    if (!days.length) {
      return false;
    }
    const wd = t.getDay() === 0 ? 7 : t.getDay(); // 1=周一...7=周日
    if (days.indexOf(wd) < 0) {
      return false;
    }
    return inWindow;
  }
  if (item.remindType == REMIND_TYPE_MONTHLY) {
    if (t.getDate() !== (item.byMonthDay || 1)) {
      return false;
    }
    return inWindow;
  }
  return false;
}

//本次提醒到点的去重key（同一时刻只弹一次横幅）
export function reminderFireKey(item, now) {
  const t = now != null ? new Date(now) : new Date();
  if (!item) {
    return "";
  }
  if (item.remindType == REMIND_TYPE_ONCE) {
    return item.id + "-t" + (item.notRepeatTime || 0);
  }
  const hm = byDayTimeToHHmm(item.byDayTime).split(":");
  const h = parseInt(hm[0], 10);
  const m = parseInt(hm[1], 10);
  const d = new Date(t);
  d.setHours(h, m, 0, 0);
  return item.id + "-" + d.getTime();
}
